import { Icons } from "@ster/ster-toolkit";
import { Tooltip } from "antd";
import classNames from "classnames";
import React, { ReactNode } from "react";

import styles from "./HelpText.module.less";

const HelpText = ({ text }: { text: string | ReactNode }): JSX.Element => (
  <Tooltip title={text}>
    <span className={classNames("help-text", styles.helpText)}>
      <Icons.QuestionIcon width={16} height={16} />
    </span>
  </Tooltip>
);

export default HelpText;
